import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';


class RenewSubscriptionController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        'ArchiSmallServices'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchismallService: ArchiSmallServices
    ) {
        let user = store.get('user');

        if ($rootScope.userTypes[user.subscription.subscriptionType] !== 'archismall') {
            $state.go('unsubscription.unsubscription-index');
        }

        $scope.cancelRenew = () => {
            $state.go('unsubscription.unsubscription-index');
        };

        $scope.renewSubscription = () => {
            ArchismallService.renewSubscription()
                .then((response) => {
                    $scope.user = response;
                    store.set('user', $scope.user);
                    $state.go('unsubscription.renew-subscription-summary');
                });
        };
    }
}

export const RenewSubscriptionComponent: ng.IComponentOptions = {
    template: require('./renew-subscription.html'),
    controller: RenewSubscriptionController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/renew-subscription/renew-subscription.ts